/*
    Prop Meta **
*/

export type PGARounds = 1 | 2 | 3 | 4 | 5 | 6;
export type PGAHoles =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18;

export type PGAPropMeta = {
  league: 'pga';
  data: PGAPropMetaRound | PGAPropMetaHole;
};

export type PGAPropMetaRound = {
  type: 'round';
  round: PGARoundScore;
};

export type PGARoundScore = {
  type: 'round_strokes';
  round: PGARounds; // soon to be deprecated -> keeping in for ts-frontend gameline
};

export type PGAPropMetaHole = {
  type: 'hole';
  hole: PGAHoleScore | PGAMultiHoleScore;
};

type PGAHoleScore = {
  type: 'hole_strokes';
  round: PGARounds; // soon to be deprecated -> keeping in for ts-frontend gameline
  hole: PGAHoles;
};

type PGAMultiHoleScore = {
  type: 'multi_hole_strokes';
  round: PGARounds; // soon to be deprecated -> keeping in for ts-frontend gameline
  multi_hole: PGAHoles[];
};

export type GolfRoundMeta = {
  type: 'golf_round';
  data: {
    round_sequence: number;
  };
};

export type PropMeta = PGAPropMeta | GolfRoundMeta;

export function getRoundFromMeta(meta?: PropMeta): number | undefined {
  if (!meta?.data) return undefined;

  if ('round_sequence' in meta.data) return meta.data.round_sequence;
  if ('round' in meta.data) return meta.data.round.round;

  return undefined;
}
